<template>
  <modal v-if="isOpen" class-name="static-info-modal" @close="$emit('close')">
    <template #body>
      <div>
        <h1 class="page-headline">Geschäftsbedingungen für Nutzer (AGB-Nutzer)</h1>
        <h3>I. Geltungsbereich der AGB und Rechtsverhältnisse</h3>
        <h4>
          1. Geltungsbereich der AGB für Nutzer (AGB-Nutzer)
        </h4>
        <p>
          1.1. Die nachfolgenden Allgemeinen Geschäftsbedingungen für Nutzer (AGB-Nutzer) gelten
          immer dann, wenn Interessenten (im folgenden: Nutzer) die über den frei zugänglichen Teil
          des Internetauftritts (im folgenden: Internetplattform) der PKW.de Digital Mobility Solutions GmbH (im
          folgenden: PKW.de) angebotenen Dienste (Suchfunktion oder Ankaufs-Service, vgl. Ziff. 2.1)
          nutzen.
        </p>
        <p>
          1.2. Für die Nutzung durch Händler gelten ausschließlich die »Allgemeinen
          Geschäftsbedingungen für Händler« (AGB-Händler).
        </p>
        <p>
          1.3. Für das Verhältnis zwischen PKW.de und dem Nutzer gelten ausschließlich die
          AGB-Nutzer von PKW.de. Abweichende Bestimmungen eines Nutzers gelten nur, wenn deren
          Geltung ausdrücklich schriftlich vereinbart wurde. Durch die Nutzung der
          PKW.de-Datenbanken des offenen Bereichs erkennt der Nutzer die Geltung der AGB-Nutzer in
          der jeweils geltenden Fassung an.
        </p>
        <p>
          1.4. Änderungen der AGB-Nutzer werden durch die Bereitstellung auf den Seiten von PKW.de
          bekannt gegeben.
        </p>
        <h4>
          2. Vertragsgegenstand, Rechtsverhältnisse
        </h4>
        <p>
          2.1. PKW.de bietet Nutzern über die Internetplattform verschiedene Dienstleistungen an, so
          die Suche in Datenbanken, in denen gewerbliche Händler Kraftfahrzeuge zum Verkauf anbieten
          (im folgenden: Suchfunktion) sowie die Möglichkeit, den statistischen Verkaufswert eines
          gebrauchten Fahrzeugs feststellen und dieses einem Händler zum Ankauf anbieten zu lassen
          (im folgenden Ankaufs-Service).
        </p>
        <p>
          2.2. Im Hinblick auf die Suchfunktion schafft PKW.de schafft lediglich die technischen
          Voraussetzungen für die Einstellung, Freischaltung und Einsehbarkeit der Verkaufsangebote.
          Im Hinblick auf den Ankaufs-Service leitet PKW.de lediglich, sofern vom Nutzer gewünscht,
          auf Basis der vom Nutzer mitgeteilten Fahrzeugdaten und des ermittelten statistischen
          Verkaufswerts das Verkaufsgesuch an einen oder mehrere Händler weiter. Auf den Inhalt der
          Inserate bzw. Verkaufsgesuche hat PKW.de keinen Einfluss. Ein Vertrag über den An- oder
          Verkauf eines Fahrzeugs kommt ausschließlich zwischen Käufer und Verkäufer zustande;
          hieran ist PKW.de in keiner Weise beteiligt.
        </p>
        <h4>
          3. Rechtliche Stellung von PKW.de
        </h4>
        <p>
          3.1. PKW.de ist in die Beziehung zwischen Anbieter und Kaufinteressent oder Käufer weder
          als Vermittler, noch als Partei oder als Vertreter einer Partei eingebunden.
          Verantwortlich für den Inhalt der Inserate ist ausschließlich der Händler, für die
          Fahrzeugbeschreibung bei Verkaufsgesuchen ist ausschließlich der Nutzer verantwortlich.
        </p>
        <p>
          3.2. Ein Vertrag über den An- oder Verkauf eines Fahrzeugs kommt ausschließlich zwischen
          Käufer und Verkäufer zustande; hieran ist PKW.de in keiner Weise beteiligt.
        </p>
        <p>
          3.2. PKW.de speichert als Diensteanbieter im Sinne des Teledienstegesetzes (TDG) lediglich
          für die Händler Informationen und stellt diese auf der Internetplattform zum Abruf durch
          den Nutzer zur Verfügung.
        </p>
        <p>
          3.3. Für die Durchsetzbarkeit der angebahnten oder geschlossenen Kaufverträge nach dem
          Landesrecht eines berührten Staates übernimmt PKW.de keine Gewährleistung und Haftung. Das
          gleiche gilt für die Entstehung sonstiger rechtlicher und wirtschaftlicher Nachteile der
          Kaufvertragsparteien.
        </p>
        <h3>II. Spezielle Regelungen für die Suchfunktion</h3>
        <h4>
          4. Bereitstellung von Daten, Überprüfung
        </h4>
        <p>
          4.1. PKW.de speichert als Diensteanbieter im Sinne des Teledienstegesetzes (TDG) lediglich
          für die Händler Informationen und stellt diese auf der Internetplattform zum Abruf durch
          den Nutzer zur Verfügung.
        </p>
        <p>
          4.2. Eine Verpflichtung von PKW.de zur Überprüfung der Rechtmäßigkeit und Richtigkeit der
          gespeicherten Inserate in Bezug auf Inhalt und Aufmachung besteht nicht.
        </p>
        <p>
          4.3. PKW.de übernimmt keine Gewähr dafür, dass die Inserate die gesetzlichen Anforderungen
          des Landes, in dem sie aufgerufen werden können erfüllen oder in dem der Fahrzeugverkäufer
          und -käufer oder Vermittler seinen Sitz hat.
        </p>
        <h4>
          5. Suche nach Verkaufsangeboten
        </h4>
        <p>
          5.1. Die Suche nach Kraftfahrzeugen über die Internetplattform und die Ausgabe von
          Suchergebnisse erfolgt ausschließlich über die von PKW.de angebotenen Suchfunktionen. Eine
          Suche unter Umgehung dieser Suchfunktion ist unzulässig. Dies gilt insbesondere für
        </p>
        <ul>
          <li>
            die automatisierte Abfrage der über die Internetplattform zugänglichen Datenbanken
            mittels externer Software
          </li>
          <li>
            oder das Kopieren der Inhalte der Datenbank (einzeln oder in ihrer Gesamtheit) und das
            Zugänglichmachen auf anderen Internetseiten oder in anderen Medien,
          </li>
        </ul>
        <p>
          5.2. Zuwiderhandlungen werden unter anderem unter dem Gesichtspunkt des Eingriffs in den
          eingerichteten und ausgeübten Gewerbebetrieb zivilrechtlich verfolgt und haben unter dem
          Gesichtspunkt des unerlaubten Eingriffs in verwandte Schutzrechte nach den §§ 108 ff. des
          Urhebergesetzes strafrechtliche Konsequenzen.
        </p>
        <h4>6. Kontaktaufnahme des Nutzers zu Händlern</h4>
        <p>
          6.1. Bei den Telefonnummern der Händler welche in den Inseraten auf der Internetplattform
          angegeben sind, handelt es sich teilweise um sog. Tracking-Rufnummern, die von PKW.de
          eingerichtet wurden. Ruft ein Nutzer zum Zweck der Kontaktaufnahme einen Händler unter
          einer derartigen Telefonnummer an, so werden von PKW.de die um die drei letzten Ziffern
          gekürzte Rufnummer des Nutzers sowie Datum und Uhrzeit des Anrufs zum Zweck der Abrechnung
          mit dem Händler und zu Statistikzwecken gespeichert. Eine Identifikation des Nutzers ist
          nicht möglich, personenbezogene Daten werden nicht gespeichert. In keiner Weise werden
          Gesprächsinhalte aufgezeichnet.
        </p>
        <p>
          6.2. In der Regel bietet PKW.de dem Nutzer auch die Möglichkeit der Kontaktaufnahme über
          ein auf der Profilseite des Händlers befindliches Kontaktformular an.
        </p>
        <h4>
          7. Kaufpreisbewertung durch PKW.de (Super Preis, Fairer Preis)
        </h4>
        <p>
          7.1. Als besonderen Service bewertet PKW.de die auf Nutzeranfragen hin gefundenen
          Suchergebnisse im Hinblick darauf, ob das betreffende Fahrzeug gemessen an einer von
          PKW.de aufgestellten statistisch ermittelten Referenz der geforderten Preise für
          vergleichbare Fahrzeuge preisgünstig oder sogar sehr preisgünstig angeboten wird .
        </p>
        <p>
          7.2. Dabei ermittelt ein speziell von PKW.de entwickelter Suchalgorithmus aus einer
          aktuellen Datenbank mit mehr als 1 Mio. Fahrzeuginseraten unter Berücksichtigung der vom
          Nutzer konkret gesuchten PKW-Modelle und Ausstattungsmerkmale den Durchschnitt des für
          Fahrzeuge mit ähnlichen Ausstattungsmerkmalen sowie vergleichbarem Fahrzeugalter und
          vergleichbarer Laufleistung von anderen Inserenten geforderten Kaufpreises. Des weiteren
          wird angegeben, um wieviel dieser Durchschnitt von einem konkreten Inserat unterschritten
          wird. Je nach dem, wie groß die Unterschreitung ist, wird das Inserat als Super Preis oder
          Fairer Preis gekennzeichnet.
        </p>
        <p>
          7.3. Die von PKW.de ermittelten durchschnittlich in Inseraten geforderten Kaufpreise
          stellen Mittelwerte dar, die regional abweichen können. Unterschiede können sich zudem
          aufgrund abweichender Details in der Ausstattung ergeben. Die Angaben basieren auf einen
          für die jeweilige km-Laufleistung und das Fahrzeugalter angemessenen durchschnittlichen
          Verschleißzustand. PKW.de hat die jeweiligen Fahrzeuge in keiner Weise begutachtet und
          vermag nicht zu beurteilen, ob im Einzelfall der Wert des Fahrzeugs aufgrund eines
          unterdurchschnittlichen Allgemeinzustands oder aufgrund spezieller Schäden oder
          Unfallfolgen von den statistisch ermittelten Angaben abweicht. PKW.de schließt
          hinsichtlich der hier unter Ziff. 6.3 genannten Punkte jegliche Haftung gegenüber dem
          Nutzer aus.
        </p>
        <h3>III. Spezielle Regelungen für den Ankaufs-Service</h3>
        <h4>8. Zulässig Nutzung, Unentgeltlichkeit</h4>
        <p>
          8.1. Der Ankaufs-Service darf nur von volljährigen und voll geschäftsfähigen Nutzern in
          Anspruch genommen werden.
        </p>
        <p>
          8.2. Über den Ankaufs-Service dürfen Nutzer nur gebrauchte Fahrzeuge verkaufen, die sich
          in einem fahrtauglichen Zustand befinden. Hingegen ist ausdrücklich das Angebot von
          solchen Fahrzeugen untersagt, die Unfallfahrzeuge (nicht repariert) sind, nicht
          fahrtüchtig sind, über keine gültige Hauptuntersuchung („TÜV“) mehr verfügen oder die
          abgemeldet sind.
        </p>
        <p>
          8.3. Die Nutzung des Ankaufs-Services ist ausschließlich über das Internetportal zulässig.
          Der Zugriff unter Umgehung des Internetportals oder die Einbindung in andere Anwendungen
          sind unzulässig.
        </p>
        <p>
          8.4. Die Nutzung des Ankaufs-Services ist für den Nutzer kostenlos.
        </p>
        <h4>9. Bewertung des Fahrzeugs</h4>
        <p>
          9.1. Damit PKW.de in der Lage ist, das Fahrzeug zu bewerten, muss der Nutzer bestimmte in
          der Eingabemaske abgefragte Fahrzeugdaten eingeben (wie z.B. Marke, Modell, Erstzulassung
          km-Stand, relevante Ausstattungsmerkmale und anderes).
        </p>
        <p>
          9.2. Auf Grundlage der vom Nutzer angegebenen Fahrzeugdaten und basierend auf dem von
          PKW.de entwickelten Berechnungsalgorithmus und den in der PKW.de-Datenbank enthaltenen
          Daten erstellt PKW.de eine Prognose über einen möglichen Ankaufspreis durch einen
          gewerblichen Händler.
        </p>
        <p>
          9.3. Die so ermittelten möglichen Ankaufspreise stellen Mittelwerte dar, die regional
          abweichen können. Unterschiede können sich zudem aufgrund abweichender Details in der
          Ausstattung ergeben. Die Angaben basieren auf einen für die jeweilige km-Laufleistung und
          das Fahrzeugalter angemessenen durchschnittlichen Verschleißzustand. PKW.de hat die
          jeweiligen Fahrzeuge in keiner Weise begutachtet und vermag nicht zu beurteilen, ob im
          Einzelfall der Wert des Fahrzeugs aufgrund eines unterdurchschnittlichen Allgemeinzustands
          oder aufgrund spezieller Schäden oder Unfallfolgen von den statistisch ermittelten Angaben
          abweicht. PKW.de schließt hinsichtlich der hier unter Ziff. 9.3 genannten Punkte jegliche
          Haftung gegenüber dem Nutzer aus.
        </p>
        <p>
          9.4. PKW.de übernimmt keine Haftung dafür, dass das Gebrauchtfahrzeug tatsächlich von
          einem Händler zu dem prognostizierten Händler-Ankaufspreis angekauft wird.
        </p>
        <h4>10. Abfrage und Weitergabe von Daten des Nutzers</h4>
        <p>
          10.1. Um sein gebrauchtes Fahrzeug bewerten zu lassen, muss der Nutzer im Rahmen der
          Eingabemaske auf dem Bildschirm seine E-Mail-Adresse angeben. Entscheidet sich der Nutzer
          dazu, über PKW.de einen Händlertermin zu vereinbaren, fragt PKW.de neben dem Wunschtermin
          zusätzlich Ort bzw. Postleitzahl des Nutzers sowie die Telefonnummer des Nutzers ab. Der
          Nutzer erklärt sich mit der Bitte um Vereinbarung eines Händlertermins damit
          einverstanden, dass die vorgenannten Nutzerdaten von PKW.de an den aus Sicht von PKW.de
          geeignetsten Händler weitergeleitet werden .
        </p>
        <p>
          10.2. PKW.de verwendet die Nutzer-Daten ausschließlich zu dem in Ziff. 9.1 genannten Zweck
          und verpflichtet auch die Händler, die Nutzerdaten ausschließlich zum Zweck eines
          möglichen Fahrzeugankaufs zu verwenden und anschließend zu löschen..
        </p>
        <h4>11. Zustandekommen eines Händlertermins</h4>
        <p>
          11.1. PKW.de leitet die Terminanfrage des Nutzers, zunächst in anonymisierter Form, an
          einen oder mehrere Händler weiter, welche sich im Einzugsbereich des Nutzers befinden.
          Bekunden mehrere Händler Interesse, so wählt PKW.de anhand objektiver Kriterien den aus
          Sicht von PKW.de geeignetsten Händler aus und übermittelt diesem die bekannten
          Nutzerdaten.
        </p>
        <p>
          11.2. Der Händler nimmt unmittelbar Kontakt zum Nutzer auf, auch im Hinblick auf eine
          mögliche Terminsverschiebung.
        </p>
        <p>
          11.3. Der Nutzer erklärt sich durch die Inanspruchnahme des Ankaufs-Services damit
          einverstanden, dass PKW.de möglicherweise vor der Bearbeitung eines Terminwunsches
          telefonisch Kontakt zum Nutzer aufnimmt, um zusätzliche Details zu klären. Des weiteren
          erklärt sich der Nutzer damit einverstanden, dass PKW.de in gewissem zeitlichen Abstand
          nach dem vom Nutzer angegebenen Wunschtermin den Nutzer telefonisch oder in sonstiger
          Weise kontaktiert, und um Informationen im Hinblick auf einen möglichen Verkauf des
          Fahrzeugs und die Zufriedenheit mit dem benannten Händler erbittet.
        </p>
        <h4>12. Keine Verpflichtung zum Verkauf</h4>
        <p>
          12.1. Durch die Inanspruchnahme des Ankaufs-Services besteht, selbst nach Durchführung
          eines Termins beim Händler, für den Nutzer keine Verpflichtung, einen Kaufvertrag mit dem
          Händler zu schließen.
        </p>
        <p>
          12.2. Ob und zu welchen Konditionen das Fahrzeug verkauft wird, ist alleinige
          Verhandlungssache zwischen dem Händler und dem Nutzer.
        </p>
        <p>
          12.3. Der Nutzer erklärt sich damit einverstanden, dass der Händler PKW.de über das
          Zustandekommen eines Kaufvertrags und den vereinbarten Kaufpreis informiert.
        </p>
        <h3>IV. Allgemeine Regelungen</h3>
        <h4>13. Gewährleistung, Haftung</h4>
        <p>
          Gegenüber einem Verbraucher haftet PKW.de für Schäden aus der Verletzung des Lebens, des
          Körpers oder der Gesundheit, die auf einer fahrlässigen oder vorsätzlichen
          Pflichtverletzung beruhen. Ferner haftet PKW.de gegenüber einem Verbraucher für sonstige
          Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung von PKW.de,
          seiner gesetzlichen Vertreter oder seiner Erfüllungsgehilfen beruhen. Die darüber hinaus
          gehende Haftung ist ausgeschlossen, sofern nicht eine vertragliche Kardinalspflicht
          verletzt wird, d.h. die Verletzung einer solchen Pflicht, die für den Nutzer für die
          Erreichung des Vertragszwecks von wesentlicher Bedeutung ist.
        </p>
        <h4>14. Urheberrechte, Nutzungsrechte</h4>
        <p>
          14.1. Die von PKW.de betriebenen und über die Internetplattform zugänglich gemachten
          Datenbanken sind nach den §§ 108 ff. des Urhebergesetzes vor Missbrauch geschützt. Ein
          Missbrauch kann mit Geldstrafe oder mit Freiheitsstrafe bestraft werden.
        </p>
        <p>
          14.2. Alle Daten, Informationen, Texte, Programme, Firmenzeichen, Fotos und Bilder in den
          PKW.de-Datenbanken unterliegen dem Urheberrecht. Die Nutzung, Weiterverarbeitung,
          Veränderung und Veröffentlichung in Medien aller Art sowie die Abspeicherung in anderen
          Datenbanken durch Dritte ist nur mit vorheriger schriftlicher Erlaubnis durch PKW.de
          gestattet.
        </p>
        <h4>15. Geltung deutschen Rechts, Gerichtsstand</h4>
        <p>
          15.1. Die Nutzung des Dienstleistungsangebots von PKW.de sowie diese AGB-Nutzer von PKW.de
          unterliegen in Anwendung und Auslegung ausschließlich deutschem Recht unter Ausschluss des
          deutschen internationalen Privatrechts. Die Anwendung des UN-Übereinkommens über Verträge
          über den Internationalen Warenverkauf vom 11. April 1998 ist ausdrücklich ausgeschlossen.
        </p>
        <p>
          15.2. Erfüllungsort ist Düsseldorf. Für alle Ansprüche aus und aufgrund der Nutzung des
          Internetauftritts wird Düsseldorf als Gerichtsstand vereinbart, sofern es sich bei dem
          Nutzer um einen Kaufmann im Sinne des Handelsgesetzbuches handelt. Dies gilt auch, wenn
          der Nutzer seinen Wohnsitz nach Vertragsschluss ins Ausland verlegt oder keinen
          allgemeinen Gerichtsstand in Deutschland hat.
        </p>
        <p>
          Stand 1. Januar 2017
        </p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';

export default {
  components: {
    Modal,
  },
  props: ['isOpen'],
};
</script>
